// import Vue from 'vue'
import $i from '~/i18n'

export default {
  namespaced: true,
  state: {
    listDiscuss: [],
    comments: []
  },
  mutations: {
    setListDiscuss (state, items) {
      items.forEach(element => {
        element.replies = []
      })
      state.listDiscuss = items
    },
    setReplies (state, replie) {
      state.listDiscuss[replie.index].replies = replie.replies
    },
    setListComments (state, itemms) {
      state.comments = itemms
    },
    setCommentReply (state, item) {
      state.comments[item.index].reply = []
      state.comments[item.index].reply = item.data
    }
  },
  actions: {
    async getDiscussReply (context, payload) {
      try {
        let { data } = await axios.post('/discuss-reply/get', {discuss_id: payload.discuss_id})
        if (data.state != 200) {
          return
        }
        if (data.replies.length == 0) {
          context.commit('notifications/info', { message: 'جوابی یافت نشد', title: '' }, { root: true })
        }
        context.commit('setReplies', {replies: data.replies, index: payload.index})
      } catch (error) {
        console.log(error)
      }
    },
    async discussGet (context, payload) {
      try {
        let { data } = await axios.post('/discuss/get', payload)
        if (data.state != 200) {
          return
        }
        context.commit('setListDiscuss', data.discuss)
      } catch (error) {
        console.log(error)
      }
    },
    async postDiscussNew (context, payload) {
      try {
        let { data } = await axios.post('/discuss/new', payload)
        if (data.state != 200) {
          return
        }
        context.commit('notifications/success', { message: $i.t('message.request.done'), title: '' }, { root: true })
        context.dispatch('discussGet')
      } catch (error) {
        console.log(error)
      }
    },
    async discussReplyNew (context, payload) {
      try {
        let { data } = await axios.post('/discuss-reply/new', payload.formDiscussReplyNew)
        if (data.state != 200) {
          return
        }
        context.commit('notifications/success', { message: $i.t('message.request.done'), title: '' }, { root: true })
      } catch (error) {
        console.log(error)
      }
    },
    async commentGet (context, payload) {
      try {
        let { data } = await axios.post('/comment/get', payload)
        if (data.state != 200) {
          return
        }
        context.commit('setListComments', data.comments)
      } catch (error) {
        console.log(error)
      }
    },
    async commentReplyGet (context, payload) {
      try {
        let { data } = await axios.post('/comment-reply/get', {id: payload.id})
        if (data.state != 200) {
          return
        }
        context.commit('setCommentsReply', {replies: data.replies, index: payload.index})
      } catch (error) {
        console.log(error)
      }
    },
    async commentReplyNew (context, payload) {
      try {
        let body = {
          comment: payload.comment,
          reply: payload.reply
        }
        let { data } = await axios.post('/comment-reply/new', body)
        if (data.state != 200) {
          return
        }
        context.commit('setCommentsReply', payload)
        context.commit('notifications/success', { message: $i.t('message.request.done'), title: '' }, { root: true })
      } catch (error) {
        console.log(error)
      }
    },
    async getCommentsReply (context, payload) {
      try {
        let { data } = await axios.post('/comment-reply/get', {
          comment_id: payload.id
        })
        if (data.state != 200) return
        context.commit('setCommentReply', {data: data.replies, index: payload.index})
      } catch (error) {
        console.log(error)
      }
    },
    async postCommentNew (context, payload) {
      try {
        let { data } = await axios.post('/comment/new', payload)
        if (data.state != 200) {
          return
        }
        context.commit('notifications/success', { message: $i.t('message.request.done'), title: '' }, { root: true })
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/content-courses.js